import { render, staticRenderFns } from "./Legales.vue?vue&type=template&id=363cde04&"
import script from "./Legales.vue?vue&type=script&lang=js&"
export * from "./Legales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports